function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M27.783,455.64c-3.175,3.175-7.144,4.763-11.51,4.763s-8.335-1.588-11.51-4.763 c-6.35-6.35-6.35-16.67,0-23.02l202.419-202.419L4.763,27.783c-6.35-6.35-6.35-16.67,0-23.02s16.67-6.35,23.02,0l213.929,213.929 c6.35,6.35,6.35,16.67,0,23.02L27.783,455.64z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 29,
    viewBox: "0 0 246.474 460.403"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-right-arrow.3b92de39.svg";
export { SvgComponent as ReactComponent };